import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { api } from "@/lib/api";

// Public post-payment page for guest checkout — polls Stripe status, then points to the inbox.
export default function EnrollSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let tries = 0, alive = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/checkout/status/${sid}`);
        if (!alive) return;
        if (data.payment_status === "paid") return setState("paid");
        if (data.status === "expired") return setState("error");
      } catch { /* keep polling */ }
      if (++tries < 15) setTimeout(poll, 2000); else if (alive) setState("pending");
    };
    poll();
    return () => { alive = false; };
  }, [sid]);

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 pt-32 pb-20 bg-aviana-paper" data-testid="enroll-success-page">
      <div className="max-w-xl text-center">
        {state === "checking" && <p className="text-aviana-muted" data-testid="enroll-checking"><Loader2 className="inline animate-spin mr-2" size={18} />Confirming your payment…</p>}
        {state === "paid" && (
          <div data-testid="enroll-paid">
            <MailCheck size={40} strokeWidth={1.3} className="mx-auto text-aviana-gold" />
            <h1 className="font-display text-5xl text-aviana-ink mt-6">You're <em className="italic font-serif gold-text">in.</em></h1>
            <p className="mt-6 text-aviana-muted text-[17px] leading-[1.8]">Thank you for enrolling. Check your inbox — we've sent you a link to create your account and step into your course. Your printed manual will be on its way soon.</p>
            <Link to="/login" className="btn-secondary mt-9 inline-flex">Already have an account? Sign in</Link>
          </div>
        )}
        {(state === "pending" || state === "error") && (
          <div data-testid="enroll-pending">
            <h1 className="font-display text-4xl text-aviana-ink">We're still confirming your payment.</h1>
            <p className="mt-5 text-aviana-muted leading-[1.8]">If you completed checkout, a welcome email with your account link will arrive shortly. Questions? <Link to="/contact" className="underline">Reach out to Holly</Link>.</p>
          </div>
        )}
      </div>
    </div>
  );
}
